import {
  Announcement,
  NewAnnouncementDto,
  UpdateAnnouncementDto,
} from "../models/announcement.model";
import { AnnouncementFilterDto } from "./dto/announcement-filter.dto";
import { AnnouncementFindAllDto } from "./dto/announcement-find-all-dto";
import { SubmitContactRequestDto } from "./dto/submit-contact-request.dto";
import { createUseApi, plainQueryBuilder } from "./useApi";
const config = useRuntimeConfig();
export const announcements = {
  useOwnAnnouncements: createUseApi<void, Announcement[]>({
    method: "GET",
    url: `${config.public.url}/user/current/announcements`,
    requireAuthentication: true,
  }),
  useDeleteAnnouncement: createUseApi<string, Announcement>({
    method: "DELETE",
    url: (input) => `${config.public.url}/announcements/${input}`,
    requireAuthentication: true,
  }),
  useDeleteUpdate: createUseApi<string, Announcement>({
    method: "DELETE",
    url: (input) => `${config.public.url}/announcements/update/${input}`,
    requireAuthentication: true,
  }),
  useAddAnnouncement: createUseApi<NewAnnouncementDto, Announcement>({
    method: "POST",
    url: `${config.public.url}/announcements`,
    dataBuilder: (input) => input,
    requireAuthentication: true,
  }),
  useFetchAnnouncement: createUseApi<string, Announcement>({
    method: "GET",
    url: (input) => `${config.public.url}/announcements/${input}`,
    requireAuthentication: true,
  }),
  useFetchAnnouncementBySlug: createUseApi<string, Announcement>({
    method: "GET",
    url: (input) => `${config.public.url}/announcements/slug/${input}`,
    requireAuthentication: true,
  }),
  useFetchAdminAnnouncementsList: createUseApi<
    AnnouncementFindAllDto,
    Announcement[]
  >({
    method: "GET",
    url: `${config.public.url}/announcements`,
    queryBuilder: plainQueryBuilder,
    requireAuthentication: true,
  }),
  useFetchAdminAnnouncementsCount: createUseApi<AnnouncementFilterDto, number>({
    method: "GET",
    url: `${config.public.url}/announcements/count`,
    queryBuilder: plainQueryBuilder,
    requireAuthentication: true,
  }),
  useApprove: createUseApi<string, void>({
    method: "PATCH",
    url: (input) =>
      `${config.public.url}/announcements/create/${input}/approve`,
    requireAuthentication: true,
  }),
  useSubmitPreview: createUseApi<string, void>({
    method: "PATCH",
    url: (input) => `${config.public.url}/announcements/create/${input}/submit`,
    requireAuthentication: true,
  }),
  useUpdateAnnouncement: createUseApi<
    { id: string; updateDto: UpdateAnnouncementDto },
    Announcement
  >({
    method: "PATCH",
    url: (inputData) => `${config.public.url}/announcements/${inputData.id}`,
    dataBuilder: (inputData) => inputData.updateDto,
    requireAuthentication: true,
  }),
  useGetUpdateAnnouncements: createUseApi<void, Announcement[]>({
    method: "GET",
    url: `${config.public.url}/announcements/update`,
    requireAuthentication: true,
  }),
  useGetUpdate: createUseApi<string, Announcement>({
    method: "GET",
    url: (inputData) =>
      `${config.public.url}/announcements/update/${inputData}`,
    requireAuthentication: true,
  }),
  useUpdateAnnouncementAfterCreation: createUseApi<
    { id: string; updateDto: UpdateAnnouncementDto },
    Announcement
  >({
    method: "PATCH",
    url: (inputData) =>
      `${config.public.url}/announcements/update/${inputData.id}/approve`,
    dataBuilder: (inputData) => inputData.updateDto,
    requireAuthentication: true,
  }),
  useHomePageAnnouncements: createUseApi<void, Announcement[]>({
    method: "GET",
    url: `${config.public.url}/announcements/home`,
    requireAuthentication: false,
  }),
  useAnnouncementIndustries: createUseApi<void, string[]>({
    method: "GET",
    url: `${config.public.url}/announcements/industries`,
  }),
  useAnnouncementRegions: createUseApi<void, string[]>({
    method: "GET",
    url: `${config.public.url}/announcements/regions`,
  }),
  usePublicAnnouncementsList: createUseApi<
    AnnouncementFindAllDto,
    Announcement[]
  >({
    method: "GET",
    url: `${config.public.url}/announcements/public`,
    queryBuilder: plainQueryBuilder,
  }),
  usePublicAnnouncementsCount: createUseApi<AnnouncementFindAllDto, number>({
    method: "GET",
    url: `${config.public.url}/announcements/public/count`,
    queryBuilder: plainQueryBuilder,
  }),
  useSimilarAnnouncementsList: createUseApi<string, Announcement[]>({
    method: "GET",
    url: (inputData) =>
      `${config.public.url}/announcements/${inputData}/similar`,
    queryBuilder: () => ({ limit: 6 }),
  }),
  // [announcementId, dto]
  useSubmitContactRequest: createUseApi<
    [string, SubmitContactRequestDto],
    void
  >({
    method: "POST",
    url: (inputData) =>
      `${config.public.url}announcements/${inputData[0]}/contact`,
    dataBuilder: (inputData) => inputData[1],
  }),

  useLogView: createUseApi<string, void>({
    method: "POST",
    url: (inputData) =>
      `${config.public.url}announcements/${inputData}/log-view`,
  }),
};
